import styled from "styled-components";

export const FooterContainer = styled.footer`
  height: 6vh;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  bottom: 0;

  @media (min-width: 768px) {
    justify-content: end;
    flex-direction: row-reverse;
    height: 6vh;
    bottom: 0;
  }
`;
// position: absolute;
// height: 6vh;
// width: 80%;
// flex-direction: row;
// align-items: center;
// justify-content: center;
// clear: both;
// margin-top: 0px;
// padding-top: 0px;
// overflow: visible;

// @media (min-width: 768px) {
//   justify-content: end;
//   flex-direction: row-reverse;
//   height: 6vh;
//   bottom: 0;
// }
